import React from "react";
import Gauge from "../basics/gauge/Gauge";
import {Placeholder} from "react-bootstrap";
import "./_skeleton.scss";

export default function SkeletonGauge({label}) {
    return (
        <div className="skeleton-gauge">
            <Gauge label={label} />
            {!label && <Placeholder className="w-25" />}
        </div>
    );
}
